
<script>
  import { createEventDispatcher } from 'svelte';
  const dispatch = createEventDispatcher();
  export let modal;
  export let referrer;
  let loading = false;
  let pathname = window.location.pathname;

  function submitHandler(e) {
    e.currentTarget.blur();
    loading = true;
    document.getElementById("emailForm").submit();
  }

  function closeHandler(e) {
    e.currentTarget.blur();
    dispatch("message", {
        type: "modal"
    });
  }
</script>

<div class="modal modal-sm {modal ? "active" : ""}">
    <div class="modal-overlay" on:click={closeHandler} aria-label="Close"></div>
    <div class="modal-container">
        <div class="modal-header">
            <ul class="tab tab-bar">
              <li class="tab-item active">
                <button class="btn btn-link" style="cursor:default;">
                  Sign In
                </button>
              </li>
              <li class="tab-item tab-action">
                <button class="btn btn-clear float-right" on:click={closeHandler} aria-label="Close"></button>
              </li>
            </ul>
        </div>
        <div class="modal-body">
            <form id="emailForm" class="content" action="/account/login" method="POST" on:submit|preventDefault={submitHandler}>
                <input type="hidden" name="returnUrl" value={pathname} />
                <input type="hidden" name="referrer" value={referrer} />
                <div class="form-group">
                  <input type="text" class="form-input input-lg is-success" name="email" placeholder="Email Address">
                  <p class="form-input-hint">If you don't receive an email, please try again.</p>
                </div>
                <input type="submit" style="position: absolute; left: -9999px"/>
                <div class="btn-group btn-group-block">
                {#if loading}
                  <button class="btn btn-lg btn-primary loading">Submit</button>
                {:else}
                  <button class="btn btn-lg btn-primary" on:click|preventDefault={submitHandler}>Submit</button>
                {/if}   
                </div>
            </form>
        </div>
    </div>
</div>

<style>
  .form-group {
    margin: 0;
  }
  p {
    margin: 0;
  }
  .modal.modal-sm .modal-container {
    padding: 0;
  }
  .tab {
    margin-top: 0;
    padding: 0 0.8rem 0 0;
    border-color:  #00ab5f;
    border-width: 0.1rem;
  }
  .tab-item {
    width: 100px;
    text-align: center;
  }
  .tab-item .btn-link {
    width: 100%;
  }
  .tab.tab-bar .tab-item.active .btn-link {
    border-bottom-color: transparent;
  }
  .modal-header {
    padding: 0;
  }
  form input:not(:first-child) {
    margin-top: 0.4rem;
  }
  .btn-group {
    padding-top: 0.8rem;
  }
</style>